import { type PropsWithChildren } from "react";
import { I18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";
import { getPreferredLanguage } from "@/locales/utils.ts";
import { messages as cs } from "./messages/cs";
import { messages as en } from "./messages/en";

i18n.load({ cs, en });
i18n.activate(getPreferredLanguage());

export function LocalesProvider({ children }: PropsWithChildren) {
  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
